<div class="favourites-container">
  <app-listing-gallery-view
    *ngIf="favourites && favourites.length"
    [selectedClusterListings]="favourites"
    [isFavouritesPage]="true"
    [confirmUnfavourite]="true"
    (itemClicked)="onFavouriteClicked($event)"
  ></app-listing-gallery-view>

  <div *ngIf="favourites && favourites.length == 0" class="full-height no-favourites text-center is-flex has-flex-align-center has-flex-content-center">
    <div>
      {{ 'my-remax.no-saved-listings' | translate }}
      <br>
      <a href="#" (click)="$event.preventDefault(); wentToFindSome.emit()" [translate]>my-remax.no-saved-listings-cta</a>
    </div>
  </div>
</div>
